import { createFileRoute } from '@tanstack/react-router'
import { CheckinScreen } from '@/features/checkin/checkin-screen'

export const Route = createFileRoute('/_app/checkin')({ component: CheckinScreen })
